import template from './swag-language-pack-settings-icon.html.twig';

const { Component } = Shopware;

/** @deprecated tag:v6.0.0 - Will be removed without replacement */
Component.register('swag-language-pack-settings-icon', {
    template,
});
